import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxPopupModule,DxButtonModule, DxNumberBoxModule, DxDataGridModule, DxDropDownBoxModule, DxTreeViewModule, DxSelectBoxModule, DxLoadIndicatorModule, DxScrollViewModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PumpcalcCoreComponent } from './pumpcalc-core.component';
import { FooterComponent } from './footer/footer.component';
import { NumberFieldComponent } from './number-field/number-field.component';
import { DatatypesService } from './datatypes.service';
import { StandardPipeSelectorComponent } from './standard-pipe-selector/standard-pipe-selector.component';
import { GasSelectorComponent } from './gas-selector/gas-selector.component';
import { GasService } from './gas.service';
import { DataCacheService } from './data-cache.service';
import { RestDataService } from './rest-data.service';
import { NgUnitsModule } from 'ng-units';
import { systemOfUnitsInitializer } from './system-of-units-initializer';
import { FormattingService } from './formatting.service';
import { StatusBarComponent } from './status-bar/status-bar.component'
import { PipeworkComponent } from './pipework/pipework.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
//import { MsalModule, MsalInterceptor, MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR } from '@azure/msal-angular';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UIEventsService } from './ui-events.service';
import { MsalComponent } from './msalcomponent/msal.component';
import { UnitsSelector } from './units-selector/units-selector.component';
import { UnitsSettingsComponent } from './units-settings/units-settings.component';
import { AppEventService } from './app-event.service';
import { UnitSettingsDialogueComponent } from './unit-settings-dialogue/unit-settings-dialogue.component';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { HeaderComponent } from './header/header.component';
import { LoaderComponent } from './loader/loader.component';
import { UserService} from './user.service';
import { MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { PumpSetSvgComponent } from './pumpSet-svg/pumpSet-svg.component';
import { LabelSvgComponent } from './label-svg/label-svg.component';
import { PipeworkSvgComponent } from './pipework-svg/pipework-svg.component';
import { PipeworkSvgService } from './pipework-svg/pipework-svg.service';
import { PumpSetSvgService } from './pumpSet-svg/pumpSet-svg.service'
import { UtilsService } from './utils.service';
import { DiagramSelectionService } from './diagram-selection.service';

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
export const isIframe = window !== window.parent && !window.opener;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: 'ddb09d67-b5ea-4442-b7f5-0d349a1d261a',
      authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('http://localhost:3000/api/',['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}


export function getMyFactory(): () => Window {
  const res = () => window;
  return res;
}

@NgModule({
  declarations: [
    PumpcalcCoreComponent,
    HeaderComponent,
    FooterComponent,
    NumberFieldComponent,
    StandardPipeSelectorComponent,
    GasSelectorComponent,
    StatusBarComponent,
    PipeworkComponent,
    LoginComponent,
    MsalComponent,
    UnitsSelector,
    UnitsSettingsComponent,
    UnitSettingsDialogueComponent,
    TopMenuComponent,
    HeaderComponent,
    LoaderComponent,
    LabelSvgComponent,
    PumpSetSvgComponent,
    PipeworkSvgComponent
  ],

  providers: [
    DatatypesService,
    GasService,
    DataCacheService,
    RestDataService,
    FormattingService,
    UIEventsService,
    HttpClient,
    AppEventService,
    UserService,
    PumpSetSvgService,
    PipeworkSvgService,
    UtilsService,
    DiagramSelectionService
  ],

  imports: [
    DxNumberBoxModule,
    DxDataGridModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxSelectBoxModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    NgUnitsModule.forRoot(systemOfUnitsInitializer()),
    MsalModule,
    HttpClientModule,
  ],

  exports: [
    PumpcalcCoreComponent,
    FooterComponent,
    NumberFieldComponent,
    StandardPipeSelectorComponent,
    GasSelectorComponent,
    StatusBarComponent,
    PipeworkComponent,
    LoginComponent,
    MsalComponent,
    UnitsSelector,
    UnitsSettingsComponent,
    UnitSettingsDialogueComponent,
    TopMenuComponent,
    HeaderComponent,
    LoaderComponent,
    LabelSvgComponent,
    PumpSetSvgComponent,
    PipeworkSvgComponent
  ]
})

export class PumpcalcCoreModule {
  public static forRoot(app_config): ModuleWithProviders<PumpcalcCoreModule> {
    return {

      ngModule: PumpcalcCoreModule,
      providers: [
        GasService,
        { provide: 'app_config', useValue: app_config },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: ()=>{
            return new PublicClientApplication({
              auth: {
                clientId: 'ddb09d67-b5ea-4442-b7f5-0d349a1d261a',
                authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
                redirectUri: app_config.app_config.redirectUrl,
                postLogoutRedirectUri: '/'
              },
              cache: {
                cacheLocation: BrowserCacheLocation.LocalStorage,
                storeAuthStateInCookie: isIE, // set to true for IE 11
              },
              system: {
                loggerOptions: {
                  loggerCallback,
                  logLevel: LogLevel.Info,
                  piiLoggingEnabled: false
                }
              }
            });
          }
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory:()=>{
            const protectedResourceMap = new Map<string, Array<string>>();
            protectedResourceMap.set(app_config.app_config.apiRootURL,['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']);
            return { interactionType: InteractionType.Redirect, protectedResourceMap };
          }
        },

        // {
        //   provide: MSAL_CONFIG, useValue: {
        //     auth: { clientId: '756e3656-80cc-4c5a-ab25-ced6c6fe7d0f', authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/', redirectUri: app_config.app_config.redirectUrl }, cache: { cacheLocation: 'localStorage', }, popUp: false,
        //     unprotectedResources: [],
        //     consentScopes: [
        //       "https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user",
        //       "https://graph.microsoft.com/profile",
        //     ],
        //     protectedResourceMap: [
        //       [app_config.app_config.apiRootURL, ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']],
        //     ],
        //   }
        // },
        // {
        //   provide: MSAL_CONFIG_ANGULAR, useValue: {
        //     auth: { clientId: '756e3656-80cc-4c5a-ab25-ced6c6fe7d0f', authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/', redirectUri: app_config.app_config.redirectUrl }, cache: { cacheLocation: 'localStorage', }, popUp: false,
        //     unprotectedResources: [],
        //     consentScopes: [
        //       "https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user",
        //       "https://graph.microsoft.com/profile",
        //     ],
        //     protectedResourceMap: [
        //       [app_config.app_config.apiRootURL, ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']],
        //     ],
        //   }
        // },
        // {
        //   provide: HTTP_INTERCEPTORS,
        //   useClass: MsalInterceptor,
        //   multi: true
        // },
        MsalService,
        MsalBroadcastService,
        LoginService
      ],
    };
  }
}
